import React from 'react'
import { ProductModel } from '@wolf/entities'
import { getTranslations } from '../TranslationTemplate'

type Translations = ReturnType<typeof getTranslations>

type Props = {
  allergens: ProductModel['allergens']
  t: Translations
}

export const AllergensBlock: React.FC<Props> = ({ allergens, t }) => {
  const tracesText = Object.entries(allergens)
    .filter(([key, value]) => !value && key !== 'lupine')
    .map(([key]) => t.allergens[key].toLowerCase())
    .reduce((acc, item, index, arr) =>
      index === arr.length - 1 && arr.length > 1
        ? `${acc} y ${item}`
        : index === 0
          ? item
          : `${acc}, ${item}`
    , '')

  return (
    <div className="allergen">
      {Object.entries(allergens).map(([key, value]) => {
        if (value)
          return (
            <div className="allergen-icon" key={key}>
              <img src={`/images/${key}.svg`} />
              <p className="allergen-icon-text">{t.allergens[key]}</p>
            </div>
          )
      })}

      <p className="information-allergen">
        {t.allergensWarning} {tracesText}.
      </p>
    </div>
  )
}
